module.exports = __webpack_public_path__ + "app/assets/fonts/st-icons-web.woff?9399d2447def752384bae65afd032cca";


//////////////////
// WEBPACK FOOTER
// ./~/@suntransfers/st-ui/dist/styles/fonts/st-icons-web.woff
// module id = 181
// module chunks = 1